import React from 'react'
import {motion} from 'framer-motion'
import Layout from '../components/layout/Layout'
import CalendarView from '../components/calendar/CalendarView'
import {useFamily} from '../contexts/FamilyContext'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const {FiCalendar}=FiIcons

const CalendarPage=()=> {
  const {loading}=useFamily()

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">Loading calendar...</p>
          </div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <motion.div
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          className="mb-8"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-xl flex items-center justify-center">
              <SafeIcon icon={FiCalendar} className="text-white text-xl" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Family Calendar</h1>
          </div>
          <p className="text-gray-600 dark:text-gray-400">
            View and manage your family's tasks by day, week, or month
          </p>
        </motion.div>

        {/* Calendar Component */}
        <motion.div
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 0.1}}
        >
          <CalendarView />
        </motion.div>
      </div>
    </Layout>
  )
}

export default CalendarPage